export default __webpack_public_path__ + "static/media/Animals-14.2629ebd8.png";